import React, { useState, useEffect, useCallback, useRef } from "react";
import "./countdown.styles.scss";

interface time {
    days: number;
    hours: number;
    min: number;
    sec: number;
}

interface IProps {
    endTime: Date;
    handleClick: (evt: any, name: string, idx?: number) => void;
}

function Countdown({ endTime, handleClick }: IProps) {
    const [countDown, setCountDown] = useState<time>({
        days: 0,
        hours: 0,
        min: 0,
        sec: -1,
    });
    const timeoutRef = useRef<number | null>(null);

    const calculateCountdown = useCallback((endDate: Date) => {
        let diff =
            (Date.parse(new Date(endDate) + "") - Date.parse(new Date() + "")) /
            1000;

        if (diff <= 0) return false;

        const timeLeft = {
            days: 0,
            hours: 0,
            min: 0,
            sec: 0,
        };

        // calculate time difference between now and expected date
        // if (diff >= 365.25 * 86400) {
        //     // 365.25 * 24 * 60 * 60
        //     timeLeft.years = Math.floor(diff / (365.25 * 86400));
        //     diff -= timeLeft.years * 365.25 * 86400;
        // }
        if (diff >= 86400) {
            // 24 * 60 * 60
            timeLeft.days = Math.floor(diff / 86400);
            diff -= timeLeft.days * 86400;
        }
        if (diff >= 3600) {
            // 60 * 60
            timeLeft.hours = Math.floor(diff / 3600);
            diff -= timeLeft.hours * 3600;
        }
        if (diff >= 60) {
            timeLeft.min = Math.floor(diff / 60);
            diff -= timeLeft.min * 60;
        }
        timeLeft.sec = diff;

        return timeLeft;
    }, []);

    const addLeadingZeros = (value: string | number) => {
        value = String(value);
        while (value.length < 2) {
            value = "0" + value;
        }
        return value;
    };

    useEffect(() => {
        const updateCountdown = () => {
            const newDate = calculateCountdown(endTime);
            if (newDate) setCountDown(newDate);
        };

        updateCountdown();
        timeoutRef.current = setInterval(updateCountdown, 1000);
        return () => {
            if (timeoutRef.current) clearInterval(timeoutRef.current);
        };
    }, [endTime, calculateCountdown]);

    useEffect(() => {
        if (
            countDown.sec === 1 &&
            countDown.min === 0 &&
            countDown.hours === 0 &&
            countDown.days === 0 &&
            timeoutRef.current
        ) {
            clearInterval(timeoutRef.current);
            handleClick(undefined, "finish");
        }
    }, [countDown, handleClick]);

    return (
        <div className="countdown">
            <div className="countdown__title">
                <span>Time : </span>
            </div>
            <div className="countdown__detail">
                {countDown.days > 0 ? (
                    <div className="countdown__col">
                        <span>{addLeadingZeros(countDown.days)}</span>
                        <span>{countDown.days === 1 ? "Day" : "Days"}</span>
                    </div>
                ) : (
                    ""
                )}
                {countDown.days !== 0 || countDown.hours > 0 ? (
                    <div className="countdown__col">
                        <span>{addLeadingZeros(countDown.hours)}</span>
                        <span>Hours</span>
                    </div>
                ) : (
                    ""
                )}
                {countDown.hours !== 0 || countDown.min > 0 ? (
                    <div className="countdown__col">
                        <span>{addLeadingZeros(countDown.min)}</span>
                        <span>Minutes</span>
                    </div>
                ) : (
                    ""
                )}
                {countDown.min !== 0 || countDown.sec > 0 ? (
                    <div className="countdown__col">
                        <span>{addLeadingZeros(countDown.sec)}</span>
                        <span>Seconds</span>
                    </div>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
}

export default Countdown;
